<template>
  <el-row type="flex">
    <!-- <el-col :span="4">
      <div class="back_sticky">
        <el-image style="width: 140px; height: 140px" :src="banner_back" fit="cover"></el-image>
      </div>
    </el-col> -->
    <el-col :span="22" class="user_unfo">
      <div class="font_format now-wrap">Сайн байна уу. {{ userDetailGetter.phone1 }} дугаартай хэрэглэгч.</div><br>
      <div class="font_format_grey now-wrap" v-if="userDetailGetter.price && userDetailGetter.price != 0">Таны өмнөх худалдан авалтын дүн: . {{ userDetailGetter.price | formatCurrency() }}</div><br>
      <el-button @click="trackCodeAddView()" type="primary"><i class="el-icon-circle-plus-outline el-icon-right" style="margin-right: 5px;"></i>Трак код бүртгэх</el-button><br><br>
      <el-tabs v-model="activeName">
        <!-- Хэрэглэгчийн мэдээлэл -->
        <el-tab-pane name="first">
          <span slot="label">
            <i class="el-icon-user-solid font_format"></i>
            &nbsp;Хэрэглэгч
          </span>
          <el-row>
            <!-- <el-col :span="24">   <div class="profile_shape_zone">
              <div class="profile_shape">
                <b>46</b><br/>
                <span>Нийт захиалгын тоо</span>
              </div> <br/>
              <div class="profile_shape">
                <b>46</b><br/>
                <span>Нийт захиалгын тоо</span>
              </div>
              <div class="profile_shape">
                <b>46</b><br/>
                <span>Нийт захиалгын тоо</span>
              </div>
            </div>
            </el-col> -->
            <el-col :span="22" :offset="1">
              <el-form :model="userDetail" label-width="100px" :label-position="'left'">
                <el-form-item label="Овог">
                  <el-input placeholder="Хоосон" v-model="userDetail.firstName" :disabled="isDisabled">
                  {{ userDetail.firstName }}</el-input>
                </el-form-item>
                <el-form-item label="Нэр">
                  <el-input placeholder="Хоосон" v-model="userDetail.lastName" :disabled="isDisabled"></el-input>
                </el-form-item>
                <el-form-item label="Утас">
                  <el-input placeholder="Хоосон" v-model="userDetail.phone1" :disabled="isDisabled">
                  </el-input>
                </el-form-item>
                <el-form-item label="Нэмэлт утас">
                  <el-input placeholder="Хоосон" v-model="userDetail.phone2" :disabled="isDisabled"></el-input>
                </el-form-item>
                <el-form-item label="Мэйл хаяг">
                  <el-input placeholder="Хоосон" v-model="userDetail.email" :disabled="isDisabled"></el-input>
                </el-form-item>
                <p class="text_grey" v-if="this.isDisabled === true">Хаягийн мэдээлэл</p><br>
                <div v-if="this.isDisabled === true" class="p-b-20">
                  <el-button size="mini" type="primary" v-for="(item, index) in addressList" :key="index" class="m-l-10 m-b-10"
                    @click="addressDetaiView(item)">
                    {{ item.nick_name || 'Nick name байхгүй' }}
                  </el-button>
                </div>
              </el-form>
              <el-button class="w-100 m-l-10" v-if="this.isDisabled === true" type="info" size="mini" @click="changePasswordDialogOpen()">Нууц үг солих</el-button>
              <el-button class="w-100 m-l-10  m-t-10" v-if="this.isDisabled === true" type="warning" size="mini" @click="addAddress()">Хаяг нэмэх</el-button>
              <el-button  v-if="this.isDisabled === true" class="button_background_color w-100 m-t-10" size="mini" @click="buttonDisable()">
                Мэдээлэл шинэчлэх
              </el-button>
              <el-button v-if="this.isDisabled === false" class="w-100 m-t-10" type="success" size="mini" @click="save()">Хадгалах</el-button>
              <!-- <el-button class="w-100 m-t-10" size="mini" type="danger">Нууц үг шинэчлэх</el-button> -->
              <el-button class="w-100 m-t-10" size="mini" @click="logout()">Гарах</el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
        <!-- Захиалгийн явц -->
        <el-tab-pane name="second">
          <span slot="label">
            <i class="el-icon-suitcase font_format"></i>
            &nbsp;Захиалга
          </span>
          <OrderProgressComponent :trackCodesList="track_code_detail"/>
        </el-tab-pane>
      </el-tabs>
    </el-col>
    <div>
      <AddressAddDialog v-if="this.$root.addressAddDialog" :addressSelect="clickedAddress" />
      <TrackCodeAddDialog v-if="this.$root.trackCodeAddDialog" />
    </div>
    <!-- change password -->
    <el-dialog :visible.sync="changePasswordDialog" width="90%" :before-close="handleClose" center title="Нууц үг солих">
      <el-form ref="changePasswordForm" :model="form" :rules="rules">
        <el-row>
          <el-col>
            <span>Хуучин нууц үг</span> <span class="color_red">*</span>
            <el-input placeholder="Хуучин нууц үг оруулна уу" v-model="form.old_password" class="w-100 m-t-10" :type="showOldPass ? 'text' : 'password'">
              <template slot="append">
                <el-button @click="showOldPass = !showOldPass">
                  {{ showOldPass ? '👁️' : '🙈' }}
                </el-button>
              </template>
            </el-input>
          </el-col>
          <el-col class="m-t-20">
            <span>Шинэ нууц үг</span> <span class="color_red">*</span>
            <el-input placeholder="Шинэ нууц үг оруулна уу" v-model="form.new_password" class="w-100 m-t-10" :type="showNewPass ? 'text' : 'password'">
              <template slot="append">
                <el-button @click="showNewPass = !showNewPass">
                  {{ showNewPass ? '👁️' : '🙈' }}
                </el-button>
              </template>
            </el-input>
          </el-col>
          <el-col class="m-t-20">
            <span>Шинэ нууц үг /ахин оруулах/</span> <span class="color_red">*</span>
            <el-input placeholder="Шинэ нууц үг ахин оруулна уу" v-model="form.re_new_password" class="w-100 m-t-10" :type="showReNewPass ? 'text' : 'password'">
              <template slot="append">
                <el-button @click="showReNewPass = !showReNewPass">
                  {{ showReNewPass ? '👁️' : '🙈' }}
                </el-button>
              </template>
            </el-input>
          </el-col>
          <el-col class="m-t-20">
            <el-button type="success" class="w-100" :loading="loading" @click="changePassword">Хадгалах</el-button>
          </el-col>
          <el-col class="m-t-20">
            <el-alert v-if="errorMessage" type="error" :title="errorMessage" show-icon></el-alert>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </el-row>
</template>

<script>
import Profile from '@/assets/banner1.png'
// import BannerBack from '@/assets/sky_back.png'
import services from '@/helpers/services'
import AddressAddDialog from './Dialog/addressAddDialog.vue'
import OrderProgressComponent from '@/components/OrderProgressComponent.vue'
import TrackCodeAddDialog from './Dialog/trackCodeAddDialog.vue'
import {
  mapGetters
} from 'vuex'

export default {
  components: {
    AddressAddDialog,
    OrderProgressComponent,
    TrackCodeAddDialog
  },
  name: 'ProfileComponent',
  data () {
    return {
      // banner_back: BannerBack,
      activeName: 'first',
      profile: Profile,
      isDisabled: true,
      clickedAddress: {},
      addressList: [],
      track_code_detail: [],
      track_code_detail_history: [],
      userDetail: {
        phone1: null,
        phone2: null,
        lastName: null,
        firstName: null,
        email: null
      },
      changePasswordDialog: false,
      form: {
        old_password: null,
        new_password: null,
        re_new_password: null
      },
      rules: {
        new_password: [
          { required: true, message: 'Шинэ нууц үг шаардлагатай', trigger: 'blur' },
          { min: 8, message: 'Нууц үг дор хаяж 8 тэмдэгттэй байх ёстой', trigger: 'blur' }
        ],
        re_new_password: [
          { required: true, message: 'Шинэ нууц үг дахин оруулах шаардлагатай', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.new_password) {
                callback(new Error('Шинэ нууц үг таарахгүй байна.'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      showOldPass: null,
      showNewPass: null,
      showReNewPass: null,
      loading: false,
      errorMessage: null
    }
  },
  computed: {
    ...mapGetters([
      'userDetailGetter'
    ])
  },
  created () {
    this.viewAddress()
    // this.getTrackCodeByPhoneOrderByHistory()
    this.getUserDetailById()
  },
  methods: {
    handleClose () {
      this.changePasswordDialog = false
    },
    changePasswordDialogOpen () {
      this.changePasswordDialog = true
    },
    buttonDisable () {
      this.isDisabled = !this.isDisabled
    },
    save () {
      services.updateUser(this.userDetailGetter.id, this.userDetail.firstName,
        this.userDetail.lastName, this.userDetail.email, this.userDetail.phone1,
        this.userDetail.phone2)
        .then((response) => {
          this.$alert('Таны мэдээлэл амжилттай засагдлаа.', 'Амжилттай', {
            confirmButtonText: 'Ойлголоо',
            callback: action => {
              location.reload()
            }
          })
        })
        .catch((error) => {
          this.$alert('Шинэчлэхэд алдаа гарлаа: ' + error, 'Алдаа', {
            confirmButtonText: 'Ойлголоо'
          })
        })
    },
    addAddress () {
      this.$root.addressAddDialog = true
      this.clickedAddress = null
    },
    addressDetaiView (data) {
      this.clickedAddress = data
      this.$root.addressAddDialog = true
    },
    viewAddress () {
      services.viewAddress(this.userDetailGetter.id)
        .then((response) => {
          this.addressList = response.data
        })
        .catch((error) => {
          console.error('Алдаа:', error.message)
        })
    },
    // getTrackCodeByPhoneOrderByHistory () {
    //   this.$root.fullscreenLoading = true
    //   services.getTrackCodeByPhoneOrderByHistory(this.userDetailGetter.phone1)
    //     .then((response) => {
    //       this.track_code_detail_history = response.data
    //       this.$root.fullscreenLoading = false
    //     })
    //     .catch((error) => {
    //       console.error('Алдаа:', error.message)
    //     })
    // },
    logout () {
      localStorage.clear()
      this.$router.push({
        path: '/'
      }
      )
      location.reload()
    },
    getUserDetailById () {
      services.getUserById(this.userDetailGetter.id)
        .then((response) => {
          this.userDetail = response.data
        })
        .catch((error) => {
          console.error('Аалдаа', error.message)
        })
    },
    trackCodeAddView () {
      this.$root.trackCodeAddDialog = true
    },
    handleCloseChangePassword () {
      this.$root.trackCodeAddDialog = false
      this.form.old_password = null
      this.form.new_password = null
      this.form.re_new_password = null
    },
    async changePassword () {
      try {
        if (this.form.old_password === null) {
          return this.$notify({
            title: 'Алдаа',
            message: 'Хуучин нууц үг оруулна уу',
            type: 'warning',
            duration: 3000
          })
        }
        if (this.form.new_password === null) {
          return this.$notify({
            title: 'Алдаа',
            message: 'Шинэ нууц үг оруулна уу',
            type: 'warning',
            duration: 3000
          })
        }
        if (this.form.re_new_password === null) {
          return this.$notify({
            title: 'Алдаа',
            message: 'Шинэ нууц үг ахин оруулна уу',
            type: 'warning',
            duration: 3000
          })
        }
        this.loading = true
        this.errorMessage = ''

        const payload = {
          old_password: this.form.old_password,
          new_password: this.form.new_password,
          re_new_password: this.form.re_new_password,
          phone1: this.userDetail.phone1
        }

        const response = await services.changePassword(payload)

        // Амжилттай хариу
        this.$notify({
          title: 'Амжилт',
          message: response.message || 'Нууц үг амжилттай шинэчлэгдлээ!',
          type: 'success'
        })

        this.changePasswordDialog = false
      } catch (error) {
        // Алдааны мессежийг notify-р харуулах
        this.$notify({
          title: 'Алдаа',
          message: error,
          type: 'error',
          duration: 3000
        })
      } finally {
        this.loading = false
      }
    }
  }
}

</script>

<style>
  .el-tabs__item i {
    background: #007AFF;
    padding: 7px;
    color: white;
    border-radius: 8px;
  }
  .el-form-item__label{
    font-weight: 500;
  }

  .back_sticky {
    margin-top: -50px;
    left: 10px;
  }

  .user_unfo {
    margin-top: 50px;
  }

  .img_border {
    border-radius: 10px;
  }

  .profile_shape {
    background-color:#007AFF;
    color: white;
    height: 150px;
    text-align: center;
    align-items: center;
    border-radius: 8px;
    width: 150px;
    justify-items: center;
    margin: 3%;
    align-content: center;
    margin-right: 10px;
  }

  .home_page {
    text-align: left !important;
  }
  .profile_shape_zone{
    display: flex;
  }
</style>
